import { render, staticRenderFns } from "./deviceTypeList.vue?vue&type=template&id=553b10a8&"
import script from "./deviceTypeList.vue?vue&type=script&lang=js&"
export * from "./deviceTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports